import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconVoucher = ({ height, width }) => (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width={width} height={height} viewBox='0 0 140 140'>
    <path
      fill='#D6D6D6'
      fillRule='evenodd'
      d='M116.667 29.167H23.333A5.833 5.833 0 0017.5 35v70a5.833 5.833 0 005.833 5.833h93.334A5.833 5.833 0 00122.5 105V35a5.833 5.833 0 00-5.833-5.833zM23.333 17.5c-9.665 0-17.5 7.835-17.5 17.5v70c0 9.665 7.835 17.5 17.5 17.5h93.334c9.665 0 17.5-7.835 17.5-17.5V35c0-9.665-7.835-17.5-17.5-17.5H23.333z'
      clipRule='evenodd'
    />
    <path
      fill='#D6D6D6'
      d='M35 29.167V52.5h8.75V29.167H35zM35 58.333v23.334h8.75V58.333H35zM35 87.5v23.333h8.75V87.5H35z'
    />
    <path
      fill='#BBB'
      fillRule='evenodd'
      d='M106.697 53.29a5.888 5.888 0 000-8.305 5.834 5.834 0 00-8.273 0L62.47 81.075a5.888 5.888 0 000 8.304 5.834 5.834 0 008.273 0l35.954-36.09zM91.493 78.47a10.657 10.657 0 00-3.91 8.27c0 5.896 4.762 10.676 10.636 10.676s10.636-4.78 10.636-10.676-4.762-10.676-10.636-10.676c-2.552 0-4.894.902-6.726 2.405zm-19.71-16.662a10.61 10.61 0 01-2.814.378c-5.874 0-10.636-4.78-10.636-10.676 0-5.897 4.762-10.676 10.636-10.676 5.875 0 10.636 4.78 10.636 10.676a10.677 10.677 0 01-7.822 10.298zm-2.814-6.622c1.984 0 3.636-1.621 3.636-3.676s-1.652-3.676-3.636-3.676c-1.983 0-3.636 1.62-3.636 3.676 0 2.055 1.653 3.676 3.636 3.676zm29.25 35.23c1.983 0 3.636-1.621 3.636-3.676s-1.653-3.676-3.636-3.676c-1.984 0-3.636 1.62-3.636 3.676 0 2.055 1.652 3.676 3.636 3.676z'
      clipRule='evenodd'
    />
  </svg>
)

export default Icon(IconVoucher)
